import { Component, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  title: string = "Not Found"

  constructor(private helpers: HelpersService) {
    this.helpers.setTitle("404 " + this.title)
  }

  ngOnInit(): void { }

  goBack() { window.history.back() }

}
